export default "__VITE_ASSET__cc10f515__"